import * as types from "./mutations-types";

export default {
    [types.SET_EXTRACT_LIST](state, list) {
        state.extract_list = list;
    }
};
